import { render, staticRenderFns } from "./CallCenterQueuesSetting.vue?vue&type=template&id=8556b498&scoped=true&"
import script from "./CallCenterQueuesSetting.vue?vue&type=script&lang=js&"
export * from "./CallCenterQueuesSetting.vue?vue&type=script&lang=js&"
import style0 from "./CallCenterQueuesSetting.vue?vue&type=style&index=0&id=8556b498&prod&lang=scss&scoped=true&"
import style1 from "./CallCenterQueuesSetting.vue?vue&type=style&index=1&id=8556b498&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8556b498",
  null
  
)

export default component.exports